import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://xaintro-backend.onrender.com';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const reviewService = {
  // Get all reviews (Admin only)
  getAllReviews: async () => {
    const response = await api.get('/reviews');
    return response;
  },

  // Get reviews for a specific product
  getProductReviews: async (productId) => {
    const response = await api.get(`/reviews/product/${productId}`);
    return response;
  },

  // Delete a review
  deleteReview: async (reviewId) => {
    const response = await api.delete(`/reviews/${reviewId}`);
    return response;
  },

  // Update a review (Admin or Owner)
  updateReview: async (reviewId, reviewData) => {
    const response = await api.put(`/reviews/${reviewId}`, reviewData);
    return response;
  },
};

export default reviewService;
